import React from 'react';
import { useAllCompanies, CompanyOption } from '../hooks/useAllCompanies';

interface CompanyCellProps {
  tenantId: number | null | undefined;
}

// Renders a row's company name in the Company column shown on in-scope list pages
// while SUPERADMIN is in "All Companies" mode. Looks up the name from the same cached
// company list the switcher uses — no backend response-shape change was needed since
// every row already carries its own tenantId.
const CompanyCell: React.FC<CompanyCellProps> = ({ tenantId }) => {
  const { data } = useAllCompanies();
  const companies: CompanyOption[] = data || [];
  if (tenantId == null) return <span className="text-gray-400">—</span>;
  const company = companies.find((c) => c.tenantId === tenantId);
  return <span>{company?.name || `#${tenantId}`}</span>;
};

export default CompanyCell;
